import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Seo from 'components/Seo';
import { ROUTES_PATHS } from 'const';
import { ORGANIZATION_NAME } from 'const/organization';
import err404Img from 'assets/images/404.png';
import styles from './not-found.module.scss';

const NOT_FOUND_TITLE = `Страница не найдена — ${ORGANIZATION_NAME}`;

const POPULAR_LINKS = [
  { name: 'Главная', url: ROUTES_PATHS.MAIN },
  { name: 'Доставка', url: ROUTES_PATHS.DELIVERY },
  { name: 'Контакты', url: ROUTES_PATHS.CONTACTS },
  { name: 'Сертификаты', url: ROUTES_PATHS.CERTIFICATES },
];

const NotFound = () => (
  <>
    <Seo seo={{ noindex: true, seo_title: NOT_FOUND_TITLE }} />
    <Helmet>
      <meta name="prerender-status-code" content="404" />
    </Helmet>
    <main className={styles.page}>
      <section className={styles.wrap}>
        <img
          src={err404Img}
          alt="Страница не найдена"
          className={styles.image}
        />
        <div className={styles.content}>
          <h1 className={styles.title}>Страница не найдена</h1>
          <p className={styles.subtitle}>
            Возможно, страница была удалена или перемещена. Воспользуйтесь ссылками ниже.
          </p>
          <Link to={ROUTES_PATHS.MAIN} className={styles.btn}>
            Вернуться на главную
          </Link>
          <div className={styles.popular}>
            <p className={styles.popularTitle}>Популярные разделы</p>
            <ul className={styles.links}>
              {POPULAR_LINKS.map(({ name, url }) => (
                <li key={url}>
                  <Link to={url} className={styles.link}>{name}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </main>
  </>
);

export default NotFound;
